import { Component, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import * as pbi from 'powerbi-client';
import { Report } from 'report';
import { AssetLocationService, DepotService, DashboardService, EmbedInfoService, KpiDataItemDto, LocationService, KpiRequestModel } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { SessionStorageService } from '../services/session-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { AuthService } from '../security/auth.service';

export enum Reports {
  Kpi = 1,
  Inventory
}


export class DropDownListItem {
  constructor(private i: string, private n: string) {
    this.id = i;
    this.name = n;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-reports-builder',
    templateUrl: './reports-builder.component.html',
    styleUrls: ['./reports-builder.component.scss'],
    standalone: false
})
export class ReportsBuilderComponent extends PagebaseComponent implements OnInit, OnDestroy {
  // Public variables
  showMenu: boolean = false;
  showNext: boolean = false;
  Reports = Reports;
  loading: boolean = true;
  reportToShow: Reports = Reports.Kpi;
  companyId: string = "";
  powerbi: pbi.service.Service;
  reportsContainer: HTMLElement;
  outputReportNames: boolean = false;
  fourWeekTrend: KpiDataItemDto;
  twelveWeekTrend: KpiDataItemDto;
  kpiReportEndDate: any = null;
  kpiReportStartDate: any = null;
  selectedDepotId: string[];
  selectedAssetTypeId: string[];
  selectedVehicleType: string = null;
  depotList: DropDownListItem[] = [];
  assetTypeList: DropDownListItem[] = [];
  hasMultipleDepots: boolean = false;
  isAdmin: boolean = false;

  // Kpi report
  kpiData: KpiDataItemDto[] = [];

  constructor(private _embedInfoService: EmbedInfoService, private _dashboardService: DashboardService, private _depotService: DepotService, private _assetService: AssetLocationService, pageHelperService: PageHelperService, applicationStatusService: ApplicationStatusService, private sessionStorageService: SessionStorageService, private customerSettings: CustomerSettings, private authService: AuthService) {
    super(pageHelperService, applicationStatusService, customerSettings, "Reports");
  }

  ngOnInit() {
    this.authService.isAdmin().then(result => {
      this.isAdmin = result;
    })
  }
   
  
  ngOnDestroy(): void {
    this.reset();
  }

  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);

    this._assetService.getAllAssetTypes(this.pageHelperService.selectedCompanyId).subscribe(data => {
      this.assetTypeList = data.map(x => new DropDownListItem(x, x));
    }, error => {
      debugger;
    });
    this._depotService.getCustomerDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {
      this.depotList = data.map(x => new DropDownListItem(x.id, x.name));
      this.hasMultipleDepots = data.length > 1;
    }, error => {
      debugger;
    });

    this.setupKpi();
  }

  exportData() {
    this.loading = true;
    this.setIsLoading(this.loading);
   
    this._dashboardService.getKPIDataExport(
      this.getRequestModel()
    ).subscribe(data => {
      this.loading = false;
      this.setIsLoading(this.loading);
      let filename = data.fileName;
      let blob: Blob = data.data;
      let a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }, error => {
      debugger;
    });
  }

  getRequestModel(): KpiRequestModel {
    var selectedKpiAssetTypeId = [];
    if (this.sessionStorageService.getItem("reports-builder-selectedKpiAssetTypeId")) {
      selectedKpiAssetTypeId = JSON.parse(this.sessionStorageService.getItem("reports-builder-selectedKpiAssetTypeId"));
      this.selectedAssetTypeId = selectedKpiAssetTypeId;
    }
    var selectedKpiDepotId = [];
    if (this.sessionStorageService.getItem("reports-builder-selectedKpiDepotId")) {
      selectedKpiDepotId = JSON.parse(this.sessionStorageService.getItem("reports-builder-selectedKpiDepotId"));
      this.selectedDepotId = selectedKpiDepotId;
    }

    var selectedVehicleType = null;
    var selectedAssetTypeClassification =  [];
    if (this.sessionStorageService.getItem("dashboard-active-selectedVehicleType")) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
      selectedAssetTypeClassification.push(VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType));
    }

    var request : KpiRequestModel = {
      customerId: this.pageHelperService.selectedCompanyId,
      startDate: this.kpiReportEndDate == null ? null:  moment(this.kpiReportEndDate),
      assetType: selectedKpiAssetTypeId,
      depotId: selectedKpiDepotId,
      assetTypeClassification: selectedAssetTypeClassification
    }

    return request;
  }

  showReport(report: Reports) {

    switch(report) {
      case Reports.Kpi:
        this.pageHelperService.setPageTitle("KPI");
        break;
      case Reports.Inventory:
        this.pageHelperService.setPageTitle("Container Report");
        this.setupUpPowerBiReport();
        break;
    }

    this.reportToShow = report;
  }

  setupKpi() {
    this.loading = true;
    this.pageHelperService.setPageTitle("KPI");
    this.setIsLoading(this.loading);

    this._dashboardService.getKPIData(this.getRequestModel()).subscribe(data => {
      this.kpiData = data.data;
      this.kpiReportEndDate = data.data[data.data.length - 1].itemDate;
      this.kpiReportStartDate = data.data[0].itemDate;
      this.twelveWeekTrend = data.twelveWeekTrend;
      this.fourWeekTrend = data.fourWeekTrend;
      this.loading = false;
      this.showNext = data.showNextButton;
      this.setIsLoading(this.loading);
    }, error => {
      debugger;
    });    
  }

  showPreviousKpiData() {
    let d = new Date(this.kpiReportStartDate);
    d.setDate(d.getDate()-7);
    this.kpiReportEndDate = d;
    this.setupKpi();
  }

  showNextKpiData() {
    const weeksToShow = 12;
    const daysInWeek = 7;
    let d = new Date(this.kpiReportEndDate);
    d.setDate(d.getDate()+  weeksToShow * daysInWeek);
    this.kpiReportEndDate = d;
    this.setupKpi();
  }

  setupUpPowerBiReport() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this._embedInfoService.getEmbedInfo(this.pageHelperService.selectedCompanyId, window.location.pathname).subscribe(data => {
      const config = {
        type: 'report',
        tokenType: 1,
        embedUrl: data.embedReport[0].embedUrl + '&language=en&formatLocale=en-GB',
        accessToken: data.embedToken.token,
        pageName: this.getReportPageName(),
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false
        }
      };
      // Grab the reference to the div HTML element that will host the report.
      this.reportsContainer = <HTMLElement>document.getElementById(
        'reportsContainer'
      );

      // Embed the report and display it within the div container.
      this.powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      this.powerbi.reset(this.reportsContainer);
      const report: Report = <Report>(this.powerbi.embed(
        this.reportsContainer,
        config
      ));

      // Report.off removes a given event handler if it exists.
      report.off('loaded');
      // Report.on will add an event handler which prints to Log window.
      report.on('loaded', function () {
        console.log('Loaded');
        if (this.outputReportNames) {
          report.getPages().then(function (pages) {
            console.log('report loaded, number of pages: ', pages.length);
            pages.forEach(function(page) {
              var log = page.name + " - " + page.displayName;
              console.log(log);
            });
            // We only want to handle the 'loaded' event once
            report.off('loaded');
          });
        }
      });

      report.off('pageChanged');
      report.on('pageChanged', e => {
        console.log(e);
      });

      report.on('error', function (event) {
        console.log(event.detail);
        report.off('error');
      });
      this.loading = false;
      this.setIsLoading(this.loading);
    }, error => {
      console.error(error)
      debugger;
    });
  }

  getReportPageName() {
    switch (window.location.pathname) {
      case "/container-register":
        return ("ReportSection328f9706e1f852397ee7")
      case "/service-frequency":
        return ("ReportSectiondac23a5deba6af13324c")
      case "/damage-report":
        return ("ReportSectionbec9c6b332122a7de479")
        case "/report-builder":
          return ("ReportSectionfa2dc67d82ef347a4e21")
      default:
        return ("")
    }
  }

  reset(): void {
    if (this.powerbi) {
      this.powerbi.reset(this.reportsContainer);
    }
  }

  toggleReportsMenu(){
    this.showMenu = !this.showMenu;
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.setupKpi();
    }
  }

  depotChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("reports-builder-selectedKpiDepotId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("reports-builder-selectedKpiDepotId")
    }
  }

  assetTypeChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("reports-builder-selectedKpiAssetTypeId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("reports-builder-selectedKpiAssetTypeId")
    }
  }

  selectedVehicleTypeValueChange(event) {
    if (event && event != '') {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(event));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }
    this.setupKpi();
  }

  showTotalContainerDays() {
    if (!this.kpiData || !this.kpiData.some(i => i.totalContainerDays)) {
      return false;
    }

    return true;
  }

  showSlowMovingDays() {
    if (!this.kpiData || !this.kpiData.some(i => i.slowMovingDays)) {
      return false;
    }

    return true;
  }

  protected checkNull(value: any) {
    if (value === undefined) {
      return null;
    }

    return value;
  }
}
